import { createContext } from 'react'

export const ItemsContext = createContext({
  selectedItemsBar: [],
  setSelectedItemsBar: () => {},
  removeItem: _item => {},
  addItem: _item => {},
  resetItemsBar: () => {},
  isModalOpen: false,
  toggleModal: () => {},
})
